import React, { useState } from "react";
import { supabase } from "../../lib/supabase";

export default function AuthModal({ onClose }) {
  const [email,  setEmail]  = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [err,    setErr]    = useState("");

  const send = async () => {
    if (!email.trim()) return;
    setStatus("sending");
    // M3 FIX: hardcoded redirect — never trust window.location.origin.
    // window.location can be spoofed in iframe contexts or by URL bar attacks.
    const redirectTo = process.env.REACT_APP_AUTH_REDIRECT_URL || "https://jade.dplhomestar.com/app";
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { emailRedirectTo: redirectTo },
    });
    if (error) { setErr(error.message); setStatus("error"); }
    else        setStatus("sent");
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"#000c", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(4px)" }}>
      <div style={{ width:380, background:"#08111e", border:"1px solid #1e3d6660", borderRadius:16, overflow:"hidden", boxShadow:"0 32px 80px #000e" }}>

        {/* Top band */}
        <div style={{ background:"linear-gradient(135deg,#0c1828,#060f1e)", padding:"28px 28px 24px", borderBottom:"1px solid #131924", position:"relative", overflow:"hidden" }}>
          <div style={{ position:"absolute", top:-30, right:-30, width:140, height:140, borderRadius:"50%", background:"radial-gradient(circle,#3b82f620,transparent 70%)" }}/>
          {/* Blueprint dots */}
          <div style={{ position:"absolute", inset:0, backgroundImage:"radial-gradient(#3b82f608 1px,transparent 1px)", backgroundSize:"20px 20px" }}/>
          <div style={{ position:"relative" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="#3b82f6" strokeWidth="1.5"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#3b82f6" strokeWidth="1.5"/>
                <line x1="12" y1="3" x2="12" y2="21" stroke="#3b82f6" strokeWidth="1.5"/>
                <circle cx="3" cy="3" r="1.5" fill="#e8a838"/>
                <circle cx="21" cy="3" r="1.5" fill="#e8a838"/>
                <circle cx="21" cy="21" r="1.5" fill="#e8a838"/>
                <circle cx="3" cy="21" r="1.5" fill="#e8a838"/>
              </svg>
              <span style={{ fontSize:11, fontWeight:800, letterSpacing:3, color:"#dde6f0", fontFamily:"'JetBrains Mono',monospace" }}>DPL JADE</span>
            </div>
            <h2 style={{ fontSize:22, fontWeight:800, color:"#dde6f0", margin:"0 0 6px", fontFamily:"'Syne',sans-serif", letterSpacing:-0.5 }}>
              {!supabase ? "Local Mode" : status === "sent" ? "Check your email" : "Sign in to sync"}
            </h2>
            <p style={{ fontSize:13, color:"#3d5068", margin:0, lineHeight:1.6 }}>
              {!supabase
                ? "Your work is saved to this browser."
                : status === "sent"
                ? `Magic link sent to ${email}`
                : "Cloud sync across devices. No password needed."}
            </p>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding:"24px 28px 28px" }}>
          {!supabase ? (
            <>
              <div style={{ background:"#0c1828", border:"1px solid #1e3d6640", borderRadius:8, padding:"14px 16px", fontSize:12, color:"#4a5e70", lineHeight:1.8, marginBottom:20 }}>
                <div style={{ color:"#e8a838", fontWeight:700, marginBottom:6, fontSize:11, fontFamily:"'JetBrains Mono',monospace" }}>RUNNING IN LOCAL MODE</div>
                To enable cloud sync, add these to <code style={{ color:"#60a5fa", background:"#060f1e", padding:"1px 5px", borderRadius:3 }}>.env.local</code>:<br/>
                <code style={{ color:"#60a5fa", fontSize:10 }}>REACT_APP_SUPABASE_URL</code><br/>
                <code style={{ color:"#60a5fa", fontSize:10 }}>REACT_APP_SUPABASE_ANON_KEY</code>
              </div>
              <button onClick={onClose} style={btnPrimary}>Continue without sync</button>
            </>
          ) : status === "sent" ? (
            <>
              <div style={{ textAlign:"center", padding:"16px 0 20px" }}>
                <div style={{ fontSize:40, marginBottom:12 }}>📬</div>
                <p style={{ fontSize:13, color:"#4a5e70", lineHeight:1.8, margin:"0 0 20px" }}>
                  Click the link in your email to sign in. The link is valid for 1 hour.
                </p>
              </div>
              <button onClick={onClose} style={btnSecondary}>Close</button>
            </>
          ) : (
            <>
              <div style={{ marginBottom:16 }}>
                <label style={{ fontSize:10, color:"#3d5068", letterSpacing:1.5, fontWeight:700, fontFamily:"'JetBrains Mono',monospace", display:"block", marginBottom:7 }}>EMAIL ADDRESS</label>
                <input
                  type="email" value={email} autoFocus
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && send()}
                  placeholder="you@example.com"
                  style={{ width:"100%", padding:"11px 14px", background:"#060f1e", border:"1px solid #1e3040", borderRadius:8, color:"#c4cdd8", fontSize:14, fontFamily:"'JetBrains Mono',monospace", outline:"none", boxSizing:"border-box", transition:"border-color .2s" }}
                  onFocus={e=>e.target.style.borderColor="#3b82f660"}
                  onBlur={e=>e.target.style.borderColor="#1e3040"}
                />
              </div>
              {status === "error" && (
                <div style={{ fontSize:12, color:"#f87171", marginBottom:12, padding:"8px 12px", background:"#1c0808", borderRadius:6, border:"1px solid #f8717130" }}>
                  ⚠ {err}
                </div>
              )}
              <button onClick={send} disabled={status==="sending"} style={{ ...btnPrimary, opacity: status==="sending"?0.7:1 }}>
                {status === "sending" ? "Sending…" : "Send magic link →"}
              </button>
              <button onClick={onClose} style={{ ...btnSecondary, marginTop:10 }}>
                Continue without sign in
              </button>
              <p style={{ fontSize:11, color:"#1e2a3a", textAlign:"center", marginTop:16, lineHeight:1.7 }}>
                By signing in you agree to our{" "}
                <a href="/terms" style={{ color:"#2a3a4a" }}>Terms</a> and{" "}
                <a href="/privacy" style={{ color:"#2a3a4a" }}>Privacy Policy</a>.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const btnPrimary = {
  width:"100%", padding:"12px", background:"linear-gradient(90deg,#3b82f6,#6366f1)", border:"none",
  color:"#fff", borderRadius:8, cursor:"pointer", fontSize:14, fontWeight:700,
  fontFamily:"inherit", letterSpacing:0.3,
};
const btnSecondary = {
  width:"100%", padding:"11px", background:"transparent", border:"1px solid #131924",
  color:"#3d5068", borderRadius:8, cursor:"pointer", fontSize:13, fontFamily:"inherit",
};
